// extracted by mini-css-extract-plugin
export default {"standardTable":"index_standardTable__CVrKr","header":"index_header__aESfQ","changelog":"index_changelog__q1mxh","expandedRowContainer":"index_expandedRowContainer__+c7xT"};